import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useGlobalState } from "../state";

interface Props {
  children: React.ReactNode;
}

const AuthChecker = ({ children }: Props) => {
  const navigate = useNavigate();
  const [user] = useGlobalState("user");

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>;
};

export default AuthChecker;
